import api from './api';

export async function createTransaction(order) {
    if (!order.restaurant) return {};

    const { data } = await api.post(`orders`, order);

    if (data) return data;
}
